
export default {
    data() {
        return {
            //批次的长度
            batchLength: 15,
            //批次的偏移量
            batchOffset: 0,
            //批次的总数量
            batchTotal: 0,
            //批次搜索名字
            batchNameSearch: '',
            //搜索批次的时间，已经转化格式
            batchDate: '',
            //被勾选的学生数组
            students: [],
            //批次的数组
            batchs: [],
            //当前批次的id
            currentBatchId: '',
            //学生的数组
            students: [],
            //课程数组
            lessons: [],
            //已经选择的课程
            selectedClass: [],
            //课程年度
            classYear: '',
            //绑定搜索的时间
            selectTime: '',
        }
    },
    methods: {
        //按照条件搜索批次
        searchBatch() {
            this.batchOffset = (1 - 1) * this.batchLength;
            // // console.log("shenme", this.selectTime);
            //判断时间是否输入了
            if (this.selectTime != "" && String(this.selectTime) != "null") {
                // 搜索时间的转换
                var d = new Date(this.selectTime);
                let year = d.getFullYear(),
                    month = d.getMonth() + 1 >= 10 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1),
                    day = d.getDate() >= 10 ? d.getDate() : '0' + d.getDate();
                let time = year + '-' + month + '-' + day;
                this.batchDate = time;
            }
            this.getAllBatch();

        },
        //获取已经勾选的学生数组
        handleStudentChange(val) {
            this.students = val;
        },
        //每页请求的条数发生变化时候
        handleSizeChange(val) {
            this.batchLength = val;
            this.getAllBatch();
        },
        //当前页数发生改变
        handleCurrentChange(page) {
            this.batchOffset = (page - 1) * this.batchLength;
            this.getAllBatch();
        },
        //获取已经开课的批次
        getAllBatch() {
            //如果清空时间绑定会自动挑去1970
            String(this.selectTime) == 'null' ? this.batchDate = '' : this.batchDate;
            //发送给后台的数据
            let data = {
                token: this.$store.state.authority_management,
                length: this.batchLength,
                offset: this.batchOffset,
                remarks: this.batchNameSearch,
                created_at: this.batchDate,
                state: '2'
            }
            this.$post('selected_batch/search', data).then(res => {
                this.batchs = res.data.result.data;
                this.batchTotal = res.data.result.total;
            })
        },
        //获取批次的信息：包括课程信息，学员信息
        getBatchInfo(obj) {
            this.currentBatchId = obj.id;
            //置空一下课程总价格
            this.lessonStatisticsMoney = 0;
            //发送给后端的数据
            let data = {
                selected_batch_id: obj.id,
                token: this.$store.state.authority_management,
                offset: 0,
                length: 999
            }
            //获取开课的学员
            this.$post('selected/search_group_by_user', data).then(res => {
                this.students = res.data.result.data;
                return true;
            }).then((flag) => {
                if (flag) {
                    //定义用户id数组
                    let user_id_arr = [];
                    //map循环把id放进去数据
                    this.students.map(item => {
                        user_id_arr.push(item.user_id);
                    });
                    //发送给后端的数据
                    let data = {
                        selected_batch_id: obj.id,
                        token: this.$store.state.authority_management,
                        offset: 0,
                        length: 999,
                        user_id_arr: JSON.stringify(user_id_arr)
                    }
                    //获取开课的课程
                    this.$post('selected/search_group_by_product', data).then(res => {
                        this.lessons = res.data.result.data;
                    });
                }
            })
        },
        //勾选设置年度的课程
        handleClassChange(val) {
            this.selectedClass = val;
        },
        //保存各个课程设置的年度，但是还未提交
        saveYear() {
            //判断是否勾选课程
            if (this.selectedClass.length == 0) {
                this.$message({
                    message: '请至少勾选一门课程',
                    type: 'warning'
                });
                //判断输入的年度格式是否正确
            } else if (isNaN(this.classYear) || this.classYear.length != 4 || Number.parseInt(this.classYear) < 2018) {
                this.$message({
                    message: '输入的年度格式有错误',
                    type: 'warning'
                });
            } else {
                //两重for循环给选到的课程的is_first属性给上年度,is_first是订单项里面预设年度字段
                for (let val of this.lessons) {
                    for (let v of this.selectedClass) {
                        if (val.id == v.id) {
                            val.is_first = this.classYear;
                        }
                    }
                }
                this.$alert('设置年度成功，记得确定最终保存', '设置成功', {
                    confirmButtonText: '确定',
                });
                //完成后置空选的课程数组
                this.selectedClass = [];
                this.$refs.yeartable.clearSelection();
            }
        },
        //确定保存课程
        confirmSaveYear() {
            // 学员id数组
            let user_ids = [];
            //包含年度和产品id的产品数组
            let cer_product_objs = [];
            //for循环把userids数组拼好
            for (let val of this.students) {
                // // console.log(val);
                user_ids.push(val.user_id);
            }
            //for循环把设置好年度的产品对象cer_product_objs数组拼好
            //即=>{"product_id": "200","is_first": "2222"}
            for (let val of this.lessons) {
                //如果is_first属性原本就没有，则把它置空，否则提交时候造成产品对象的is_first属性缺失，报500错误
                val.is_first == undefined ? val.is_first = '' : val.is_first;
                //组成新的临时对象
                let obj = {
                    product_id: val.product_id,
                    is_first: val.is_first
                }
                //把对象添加到即将要提交的产品数组
                cer_product_objs.push(obj);
            }
            //判断批次是否有产品和学员
            if (user_ids.length == 0 || cer_product_objs.length == 0) {
                this.$message({
                    message: '该批次没有产品或者没有学员，请修改好批次的内容',
                    type: 'warning'
                })
                return false;
            }

            let data = {
                token: this.$store.state.authority_management,
                cer_product_objs: JSON.stringify(cer_product_objs),
                user_ids: JSON.stringify(user_ids)
            }
            //发起设置产品的年度的请求
            this.$post('purchased/batch_set_cer_year', data).then(res => {
                if (res.data.status == 'success') {
                    this.$alert('设置产品年度成功', '设置成功', {
                        confirmButtonText: '确定',
                    });
                } else {
                    this.$message({
                        message: '产品设置年度失败！',
                        type: 'error'
                    })
                }
            })
        },
        //根据设定年度或者课程本身年度显示
        getYearText(obj) {
            // // console.log(obj);
                //若课程的product_cer_year存在则直接显示
            if(!this.$isAbnormal(obj.product_cer_year)){
                return "课程默认年度" + obj.product_cer_year;
            }else if (this.$isAbnormal(obj.is_first)) {
                return "未设置年度";
            } else {
                return "已设年度" + obj.is_first;
            }
            // { { (scope.row.is_first == '' || scope.row.is_first == null || scope.row.is_first.toString() == undefined) ? "未设置年度" : "已设年度" + scope.row.is_first } }
        }
    },
    created() {
        //获取已经开课的批次
        this.getAllBatch();
    }
}
